// extracted by mini-css-extract-plugin
export default {"paginatedTable":"Mm9MiIXhnncCJtjkj_Uj","activePage":"xRocI07jjXOEL1oZ1oVo","misclinks":"xQHUAPLhv9ZdcySrcaBA"};